export default {"src":"/_next/static/media/seasonsMonthsGif.553da7f0.gif","height":675,"width":1200};